<template>
  <div class="ew-auth">
    <div class="ew-auth__panel">
      <div class="ew-auth__card">
        <router-link to="/">
          <img class="ew-auth__logo" src="@/assets/images/logo-ew.png" alt="Logo Moovet">
        </router-link>

        <p class="alert alert-success ew-alert" role="alert" v-if="recoveryResult === 'success'">
          Éxito. Verifica tu correo para configurar tu nueva contraseña, ya puedes cerrar esta ventana.
        </p>
        <p class="alert alert-danger ew-alert" role="alert" v-if="recoveryResult === 'error'">
          El correo no existe.
        </p>

        <form @submit.prevent="passwordRecovery" novalidate>
          <div class="ew-form__field">
            <label class="ew-label" for="pr-email">Correo electrónico *</label>
            <input id="pr-email" type="email" class="ew-input ew-input--block" placeholder="correo@ejemplo.com" v-model="email" required>
          </div>

          <button type="submit" class="ew-btn-primary ew-auth__submit">Recuperar contraseña</button>
        </form>
      </div>
    </div>

    <div class="ew-auth__brand">
      <span class="ew-auth__brand-icon"><ph-icon name="map-pin" /></span>
      <p class="ew-auth__brand-text">Cotiza, genera y rastrea tus envíos, todo en un solo lugar.</p>
    </div>

    <a class="ew-call" href="tel:3317547337" aria-label="Llámanos">
      <img src="@/assets/images/call-answer.png" alt="">
    </a>
  </div>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import PhIcon from './icons/PhIcon'

export default {
  name: 'PasswordRecovery',
  data () {
    return {
      email: '',
      recoveryResult: 'none'
    }
  },
  methods: {
    passwordRecovery () {
      axios
        .post(`${commons.apiURL}/api/v1/password-recovery`, {
          email: this.email
        })
        .then(response => {
          console.log(response)
          this.recoveryResult = 'success'
        })
        .catch(error => {
          this.recoveryResult = 'error'
          console.error(error)
        })
    }
  },
  components: {
    'ph-icon': PhIcon
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-auth { @include app-tokens; @include ew-auth-shell; }
.ew-auth__panel { @include ew-auth-panel; }
.ew-auth__card { @include ew-auth-card; }
.ew-auth__logo { @include ew-auth-logo; }
.ew-auth__brand { @include ew-auth-brand; }
.ew-auth__brand-icon { @include ew-auth-brand-icon; }
.ew-auth__brand-text { @include ew-auth-brand-text; }

.ew-alert { font-family: var(--app-font); border-radius: var(--app-radius-sm); margin-bottom: 1.25rem; }

.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1.25rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }

.ew-btn-primary { @include ew-btn-primary; }
.ew-auth__submit { width: 100%; height: 3rem; margin-top: 0.5rem; }

.ew-call {
  position: fixed;
  bottom: 1.75rem;
  left: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  background: var(--app-accent-button);
  box-shadow: 0 4px 10px rgba(7, 50, 88, 0.25);

  img { width: 1.5rem; height: auto; }

  &:hover { background: var(--app-accent-button-hover); }
  &:focus-visible { outline: 3px solid var(--app-accent); outline-offset: 2px; }
}

@media (max-width: 400px) {
  .ew-call { width: 3rem; height: 3rem; bottom: 1.2rem; left: 1.2rem; }
  .ew-call img { width: 1.25rem; }
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordRecovery.vue